import { useQuery } from '@tanstack/react-query'

import { axios, ExtractFnReturnType, QueryConfig } from '@apps-common/lib'

export const QUERY_KEY_MY_MONITORING_GET_DEFAULT_MEDIA_IMAGES = () => ['getMyMonitoringDefaultMediaImages'].filter(Boolean)

const getMyMonitoringDefaultMediaImages = async (): Promise<string[]> =>
  axios.get('/Media/GetMyMonitoringDefaultImages').then((res) => res.data?.data)

type QueryFnType = typeof getMyMonitoringDefaultMediaImages

type Props = {
  config?: QueryConfig<QueryFnType>
}

export const useMyMonitoringGetDefaultMediaImages = ({ config }: Props) =>
  useQuery<ExtractFnReturnType<QueryFnType>>({
    ...{ ...config, gcc: 0 },
    queryKey: QUERY_KEY_MY_MONITORING_GET_DEFAULT_MEDIA_IMAGES(),
    queryFn: () => getMyMonitoringDefaultMediaImages()
  })
